import { create } from 'zustand';

// ----------------------------------------------------------------------

const searchProductStore = create((set) => ({
  searchResults: [],
  searchLoading: true,
  actions: {
    setSearchLoading: () => set({ searchLoading: true }),
    setSearchResults: (searchResults = []) => set({ searchResults, searchLoading: false }),
  },
}));

export const useSearchProductStore = () => {
  const searchResults = searchProductStore((state) => state.searchResults);
  const searchLoading = searchProductStore((state) => state.searchLoading);
  const actions = searchProductStore((state) => state.actions);

  return { searchResults, searchLoading, ...actions };
};
